export const getHeaders = () => {
  const headers: any = {
    "Content-Type": "application/json",
  };
  try {
    const auth: any = localStorage.getItem("auth");
    const { accessToken } = JSON.parse(auth);
    headers.Authorization = `Bearer ${accessToken}`;
  } catch (e) {}
  return headers;
};

const fetcher = (url: string, body: any = {}, method = "GET") => {
  const options: any =  {
    headers: getHeaders(),
    method,
  }
  if (Object.keys(body).length) {
    options.body = JSON.stringify(body)
  }
  return fetch(new URL(url, process.env.REACT_APP_API_URL), options).then(async (result) => {
    if (result.ok) return result.json();

    const error = await result.json();
    throw error;
  });
}

export default fetcher;